import React from "react";
import IssuePipelineLogo from "./../../assets/pragati-pipeline-with-shadow.svg";

function IssuePipelineReview({
  className,
  isPragatiPipeline,
  isAgendaDetail = false
}) {
  return isPragatiPipeline ? (
    <div className={isAgendaDetail ? className : className}>
      <img alt="issuePipeline" src={IssuePipelineLogo} />
    </div>
  ) : null;
}

export default IssuePipelineReview;
